export default __webpack_public_path__ + "ae1382ba862ac23731a718b4289dceb3.png";